export function downloadFile({ data, fileName, fileType }: { data: string, fileName: string, fileType: string }) {
  const blob = new Blob([data], { type: fileType })
  const a = document.createElement('a')
  a.download = fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

// Builds a CSV string from a header row and value rows, quoting and escaping every cell.
export function toCsv(headers: string[], rows: (string | number | null | undefined)[][]): string {
  const esc = (v: string | number | null | undefined) => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`;
  return [headers, ...rows].map(row => row.map(esc).join(',')).join('\r\n');
}

// Triggers a CSV download. Prefixes a BOM (U+FEFF) so Excel reads it as UTF-8.
export function downloadCsv({ csv, fileName }: { csv: string, fileName: string }) {
  downloadFile({ data: String.fromCharCode(0xFEFF) + csv, fileName, fileType: 'text/csv;charset=utf-8;' });
}

export function downloadBlob({ blob, fileName }: { blob: Blob, fileName: string }) {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.download = fileName
  a.href = url
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
  window.URL.revokeObjectURL(url)
}
